import { MessageCircle } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Story } from "@/components/site/Story";
import { Rooms } from "@/components/site/Rooms";
import { Boats } from "@/components/site/Boats";
import { Gallery } from "@/components/site/Gallery";
import { Reviews } from "@/components/site/Reviews";
import { Journal } from "@/components/site/Journal";
import { Popup } from "@/components/site/Popup";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Seo } from "@/components/site/Seo";
import { useSite, waLink } from "@/context/SiteContext";

export default function Home() {
  const { settings } = useSite();

  return (
    <div className="grain" data-testid="home-page">
      <Seo />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Rooms />
        <Boats />
        <Gallery />
        <Reviews />
        <Journal />
        <Contact />
      </main>
      <Footer />
      <Popup />
      <a
        href={waLink(settings)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-button"
        aria-label="Chat with our concierge on WhatsApp"
        className="fixed bottom-6 right-6 z-50 h-14 w-14 grid place-items-center rounded-full bg-azure text-sand shadow-[0_14px_40px_rgba(26,98,137,0.45)] transition-all hover:bg-azure-dark hover:scale-105"
      >
        <MessageCircle size={22} />
      </a>
    </div>
  );
}
